<template>
    <div class="box">
        <header :class="{'is-right': $layout.side == 'right'}">
            <div class="hamburger-box">
                <div class="hamburger-button" @click="openDrawer">
                    <i class="material-icons">menu</i>
                </div>
            </div>
            <div class="title-box">
                <p>{{$appInfo.title}}</p>
                </div>
            <div class="logo-box">
                <img :src="$appInfo.logo">
                <img class="flag" :src="notCurrentLang.icon" @click="changeLang">
                <p class="langCode">{{notCurrentLang.code}}</p>
            </div>
        </header>
    </div>
</template>

<script>
export default {
    computed: {
        notCurrentLang(){
            if(this.$i18n.locale == "fr"){
                return this.$langs[1]
            }
            else {
                return this.$langs[0]
            }
        }
    },
    methods: {
        openDrawer(){
            this.$eventBus.$emit('toggleDrawer')
        },
        changeLang(){
            this.$i18n.locale = this.notCurrentLang.code
            this.$sharedStore.set('locale', this.$i18n.locale)
        }
    }
}
</script>

<style lang="scss" scoped>
    .is-right {
        flex-direction: row-reverse;
    }

    .box {
        height: vh(20);
    }

    header {
        display: flex;
        align-items: center;
        height: vh(20);
        padding: 1vh;
        position: fixed;
        width: 100%;
        background-color: white;

        .hamburger-box {
            width: 30%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .hamburger-button {

                border-radius: 100px;
                border: solid 3px $background-dark;
                width: 40px;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;

                i {
                    color: $primary;
                }

            }
        }

        .title-box {
            padding: 0 20px;
            p {
                color: $primary;
                text-align: center;
                font-weight: bold;
                font-family: $titleFont;
                font-size: 1.3rem;
            }
        }

        .logo-box {
            width: 30%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            > img {
                object-fit: contain;
                width: 70%;
                height: 70%;
            }

            :first-child {
                margin-bottom: 10px;
            }

            :last-child {
                border-radius: 1000px;
                width: 30px;
                height: 30px;
                object-fit: cover;
            }

            .langCode {
                text-align: center;
                text-transform: uppercase;
                padding: 2px;
            }

            p {
                font-weight: bold;
            }
        }
    }

    @media screen and (min-width: 768px) and (max-width: 1024px) {
        header {
            //height: vh(10);

            .hamburger-box {
                width: 10%;
            }

            .title-box {
                width: 80%;
            }

            .logo-box {
                width: 10%;
            }
        }
    }

    .flag {
        width: 40% !important;
        object-fit: contain !important;
    }

    @media screen and (min-width: 1024px) {
        header {
            //height: vh(10);

            .hamburger-box {
                width: 10%;
            }

            .title-box {
                width: 80%;
            }

            .logo-box {
                width: 10%;
                > img {
                    width: 40%;
                }
            }
        }
    }
</style>